
export const getSuspiciousUserList = state => state.suspiciousProfiles;
export const verifySuspiciousProfile = state => state.suspiciousProfileVerifications;
export const getLoading = state => state.loading;
export const getVerificationLoading = state => state.verificationLoading;



// WEBPACK FOOTER //
// ./src/redux/suspiciousProfiles/selectors.js